import Swiper from "swiper";
import "lightgallery.js";
import "lg-video.js";
import "lg-thumbnail.js";
/* eslint-disable */

const {lightGallery} = window;
// ---- variables ----
let elMainSlider;
let elThumbSlider;
let mainSlider;
let thumbSlider;
let currentActiveSlide;
let thumbSliderSelector = 'pdp-brand-info-thumbs-slider';

/**
 * @name initThumbsSlider
 * @function
 * handles the operations needed to initialize thumbnail slider.
 * thumbnail slider will be reinitialized when the viewport resize changes
 *
 */
const initThumbsSlider = function() {
  const optTablet = {
    slidesPerView: "auto",
    direction: "horizontal",
    spaceBetween: 10,
    threshold: 50,
    navigation: {
      //pdp-brand-info__thumbs-slider__nav pdp-brand-info__thumbs-slider__nav--next
      nextEl: ".pdp-brand-info__thumbs-slider__nav--next",
      prevEl: ".pdp-brand-info__thumbs-slider__nav--prev",
      disabledClass: "pdp-thumbs-slider__nav--disabled",
    },
  };

  elThumbSlider = document.querySelector("#" + thumbSliderSelector);
  if (thumbSlider != undefined) thumbSlider.destroy(true, true);
  thumbSlider = new Swiper("#" + thumbSliderSelector, optTablet);
};

/**
 * @name syncSlideChangesToThumbnail
 * @function
 * add active class to thumbnail slider based on the active slide in main slider
 *
 */
const syncSlideChangesToThumbnail = function () {
  const prevActive = currentActiveSlide;
  currentActiveSlide = mainSlider.realIndex;

  if (thumbSlider != null) {
    if (prevActive != null) thumbSlider.slides[prevActive].classList.remove(activeThumbSliderClass);
    thumbSlider.slides[currentActiveSlide].classList.add(activeThumbSliderClass);
  }
};

/**
 * @name assignThumbsClickHandler
 * @function
 * assigns click handler to thumbnail slider slides
 */
const assignThumbsClickHandler = function () {
  if (elThumbSlider)
  for (let thumbnail of elThumbSlider.querySelectorAll(".pdp-brand-info__thumbs-slider__slide")) {
    thumbnail.onclick = handleThumbClick;
  }
};

/**
 * @name handleThumbClick
 * @function
 * click handler for thumbnail slider.
 * will trigger main slider to slide to the clicked slide in thumbnail slider
 */
const handleThumbClick = function () {
  if (mainSlider && thumbSlider)
  mainSlider.slideTo(thumbSlider.clickedIndex);
};

// forces a resize event in browser
const forceResize = () => {
  setTimeout(() => {
    const event = document.createEvent("HTMLEvents");
    event.initEvent("resize", true, false);
    window.dispatchEvent(event);
  }, 450);
};

var init = function () {
  'use strict';

  var vSelector = "pdp-brand-info-slider";

  var sliderOpt = {
    slidesPerView: 1,
    // slidesPerView: 'auto',
    threshold: 50,
    spaceBetween: 26,
    navigation: {
      nextEl: 'pdp-brand-info-slider__nav--next',
      prevEl: 'pdp-brand-info-slider__nav--prev',
      disabledClass: 'pdp-brand-info__slider-nav--disabled'
    },
  };

  var slider = document.getElementById('pdp-brand-info-slider');
  if (!slider) return;

  if (slider != undefined) {
    mainSlider = new Swiper('#' + vSelector, sliderOpt);

  }
  initThumbsSlider();

  assignThumbsClickHandler();

  var mediaGallerySliders = slider.querySelectorAll('.swiper-wrapper');
  lightGallery(mediaGallerySliders[0], {
    selector: ".swiper-slide",
    thumbnail: true,
    download: false,
    addClass: "pdp-media-lightgallery"
  });

};

export default {init};
